import { daysOfWeek, subtractBusinessDays } from "@sellar-io/common";
import dayjs from "dayjs";
import { ReactElement } from "react";
import {
  TableLegacyTR,
  TableLegacyTD,
} from "../../components/table/TableLegacy";
import { capitalize } from "../../utils/nativeLodash";
import { deliveryDays } from "./DeliveryAreaForm.shared";

const dayJsDaysOfWeek = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];
export function DeliveryAreaFormTableRow({
  orderCutOffDaysBeforeValue,
  orderCutOffTimeValue,
  day,
  includeWeekend,
}: {
  day: daysOfWeek;
  orderCutOffDaysBeforeValue: number | null;
  orderCutOffTimeValue: string | null;
  includeWeekend: boolean;
}): ReactElement {
  let orderCutOff: string | undefined;
  if (orderCutOffTimeValue && orderCutOffDaysBeforeValue) {
    const deliveryDayIndex = dayJsDaysOfWeek.indexOf(day);
    const baseDate = dayjs().set("day", deliveryDayIndex);

    // Subtract cutoff days — skipping weekends if needed
    const cutoffDate = includeWeekend
      ? baseDate.subtract(orderCutOffDaysBeforeValue, "day")
      : subtractBusinessDays(baseDate, orderCutOffDaysBeforeValue);

    const cutoffDayIndex = cutoffDate.day() - 1; // 0 = Sunday ... 6 = Saturday
    const cutoffDayName = deliveryDays[cutoffDayIndex]?.viewValue ?? "Sunday";

    orderCutOff = `${cutoffDayName} before ${orderCutOffTimeValue}`;
  }

  return (
    <TableLegacyTR>
      <TableLegacyTD>{capitalize(day)}</TableLegacyTD>
      <TableLegacyTD>{orderCutOff}</TableLegacyTD>
    </TableLegacyTR>
  );
}
